import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-pos-time-ago',
  templateUrl: './pos-time-ago.component.html',
  styleUrls: ['./pos-time-ago.component.sass'],
})
export class PosTimeAgoComponent implements OnInit {
  // LOGICA PARA CONTROLAR TIEMPOS DE CREACION DE SOLICITDES ONBASE

  // VARIABLES GLOBALES
  _initialDate: string = '';
  _closedDate: string = '';
  _control: any = '';
  _status: string = '';

  // VARIABLES PARA TITULOS DEL WIDGET
  _titleWidget: string = '';
  _subtitleWidget: string = '';
  _textWidget: string = '';
  _firstSubtitle: string = '';
  _secondSubtitle: string = '';

  // VARIABLES PARA CONTROL DE TIEMPO
  _days: number | undefined;
  _hours: number | undefined;
  _minutes: number | undefined;
  _seconds: number | undefined;

  //Emitir estados
  @Output() timerEmit: EventEmitter<Object> = new EventEmitter<Object>();

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {}

  initialControlTimer(dataTimer: any) {
    try {
      const duration = moment.duration(Number(dataTimer.time), 'seconds');
      dataTimer.status === 'PROCESSED'
        ? this.showDataCronometro(duration)
        : this.showCustomCronometro(duration);
    } catch (e) {}
  }

  showDataCronometro(duration: any): void {
    this._days = this.getDayOfMonth(duration);
    this._hours = duration.get('hours').toString().padStart(2, '0');
    this._minutes = duration.get('minutes').toString().padStart(2, '0');
    this._seconds = duration.get('seconds').toString().padStart(2, '0');
  }

  showCustomCronometro(duration: any): void {
    this._days = this.getDayOfMonth(duration);
    this._hours = duration.get('hours').toString().padStart(2, '0');
    this._minutes = duration.get('minutes').toString().padStart(2, '0');
    this._seconds = duration.get('seconds').toString().padStart(2, '0');

    if (
      !isNaN(this._days) &&
      !isNaN(this._hours!) &&
      !isNaN(this._minutes!) &&
      !isNaN(this._seconds!)
    ) {
      this._control = setInterval(() => {
        if (+this._seconds! < 59) {
          this._seconds = +this._seconds! + 1;
        } else if (+this._seconds! === 59) {
          this._seconds = 0;
          if (+this._minutes! < 59) {
            this._minutes = +this._minutes! + 1;
          } else if (this._minutes === 59) {
            this._minutes = 0;
            if (+this._hours! < 23) {
              this._hours = +this._hours! + 1;
            } else if (+this._hours! === 23) {
              this._hours = 0;
              this._days = +this._days! + 1;
            }
          }
        }
      }, 1000);
    }
  }

  getDayOfMonth(duration: any): number {
    let month = this.getMonthOfYear(duration);
    let monthToDay = month > 0 ? month * 31 : 0;
    return (monthToDay + duration.get('days')).toString().padStart(2, '0');
  }

  getMonthOfYear(duration: any): number {
    let year = duration.get('year');
    let yearToMonth = year > 0 ? year * 12 : 0;
    return yearToMonth + duration.get('month');
  }

  stop(): void {
    try {
      clearInterval(this._control);
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  getDateTime(): string {
    return `${this._days} : ${this._hours} : ${this._minutes}`;
  }

  resetData(): void {
    this._days = undefined;
    this._hours = undefined;
    this._minutes = undefined;
    this._seconds = undefined;
    this._initialDate = '';
    this._closedDate = '';
    this._titleWidget = '';
    this._subtitleWidget = '';
    this._textWidget = '';
    this._status = '';
  }

  isClosed() {
    this.timerEmit.emit({ status: true });
  }
}
